/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow_long': {
    width: 24,
    height: 41,
    viewBox: '0 0 24 41',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10.718 41h2V3.467L18 8.913l1.436-1.393-7-7.216a1 1 0 00-1.436 0L4 7.52l1.436 1.393 5.282-5.446V41z" _fill="#0B2C62"/>'
  }
})
